import { render, staticRenderFns } from "./PageBanner.vue?vue&type=template&id=ce1b9be2&scoped=true&"
import script from "./PageBanner.vue?vue&type=script&lang=js&"
export * from "./PageBanner.vue?vue&type=script&lang=js&"
import style0 from "./PageBanner.vue?vue&type=style&index=0&id=ce1b9be2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce1b9be2",
  null
  
)

export default component.exports